import { Material } from "@/store/MaterialesStore";
import { ProductoAcabado } from "@/store/ProductosAcabadoStore";
import { AxiosStatic } from "axios";

class SAPService {
  axios
  apiSAP

  constructor (axios: AxiosStatic, apiSAP: string) {
    this.axios = axios
    this.apiSAP = `${apiSAP}`
  }

  getHierarchy () {
    return this.axios.post(`${this.apiSAP}Get_Product_Hierarchy/paths/invoke`)
  }

  getProductDetails(referencia: number, centro: string) {
    const data = {
      material: referencia,
      centro: centro,
    };
    return this.axios.post(`${this.apiSAP}Get_Material_Detail/paths/invoke`, data)
  }

  getBillOfMaterials(referencia: number, centro: string) {
    const data = {
      material: referencia,
      centro: centro,
    };
    return this.axios.post(`${this.apiSAP}Get_Materiales_BOM/paths/invoke`, data)
  }

  getStatusSAP(referencia:number, centro:string) {
    const data = {
      material: referencia,
      centro: centro,
    };
    return this.axios.post(`${this.apiSAP}Get_status_SAP/paths/invoke`, data)
  }

  createMateriales(prodAcabado:ProductoAcabado, materiales:Material[], tipo:string) {
    const data = {
      TipoSAP:tipo,
      PA:prodAcabado,
      Materiales:materiales
    }
    return this.axios.post(`${this.apiSAP}RFC_Materiales_Create/paths/invoke`, data)
  }

  createPrice(prodAcabado:ProductoAcabado) {
    return this.axios.post(`${this.apiSAP}RFC-CREATE_PRICECOND/paths/invoke`, prodAcabado)
  }
}
export default SAPService;
